import { updateSubjectUseCase } from '@src/main/modules/messages/application/use-cases/update/update-subject.usecase';
import { UpdateSubjectRequest } from '@src/main/modules/messages/infrastructure/dto/updateSubjectRequest';
import { createSubjectHttpRepository } from '@src/main/modules/messages/infrastructure/repository/SubjectHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateSubject = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createSubjectHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: UpdateSubjectRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await updateSubjectUseCase(data, tokenProvider);
    },
  });
};
